<template>
  <div>
    <div class="d-flex align-items-center">
      <h1>Vehiculos</h1>
      <b-button
        v-b-tooltip.hover
        size="sm"
        :href="urlAddUser()"
        variant="primary"
        title="Agregar usuario"
        class="ml-auto"
      >
        <font-awesome-icon :icon="['fas', 'plus']"/> Vehiculo
      </b-button>
    </div>
    <b-card >
      <div class="d-flex flex-column flex-sm-row">
        <div class="">
          <b-form-group label-cols="12" label-cols-sm="4" label-cols-lg="4"  label="Buscar" label-for="input-sm">
            <b-form-input id="input-sm" v-model="search.licence_plate" @input="searching"></b-form-input>
          </b-form-group>
        </div>
        <nav aria-label="Page navigation example" class="ml-auto">
          <ul class="pagination">
            <li v-for="(item, index) in vehiclesDynamic.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
          </ul>
        </nav>
      </div>
      <!-- <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li v-for="(item, index) in vehicles.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
        </ul>
      </nav> -->
      <div>
        <Loading :active="loading" :is-full-page="true"></Loading>
        <b-table small
          :fields="tableHead"
          :items="vehiclesDynamic.data"
          responsive="sm"
        >
          <!-- A custom formatted column -->
          <template #cell(created_at)="data">
            {{ $moment(data.item.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
          <template #cell(options)="data">
            <b-button v-b-tooltip.hover size="sm" :href="urlEdit(data.item)" variant="outline-primary" title="Editar">
              <font-awesome-icon :icon="['fas', 'edit']"/>
            </b-button>
            <!-- <b-button v-b-tooltip.hover size="sm" target="_blank" variant="danger" title="Eliminar" @click="confirmDelete(data)">
              <font-awesome-icon :icon="['fas', 'trash-alt']"/>
            </b-button> -->
          </template>
        </b-table>
      </div>
      <div class="d-flex">
        <nav class="ml-auto" aria-label="Page navigation example">
          <ul class="pagination">
            <li v-for="(item, index) in vehiclesDynamic.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
          </ul>
        </nav>
      </div>
    </b-card>
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'ListVehicles',
    components:{FontAwesomeIcon},
    props:{
      vehicles:{
        required:true,
        type: Object
      },
     filters:{
        required:true,
        type: Object
      }
    },
    data() {
      return {
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'created_at', label: 'Creado' },
          { key: 'licence_plate', label: 'Placa' },
          { key: 'terminal', label: 'Terminal' },
          { key: 'options', label: 'Acciones' },
        ],
        loading:false,
        search:{
          licence_plate: this.filters.licence_plate
        },
        vehiclesDynamic: this.vehicles
      }
    },
    methods: {
      confirmDelete() {
        console.log('delete user');
        
      },
      urlEdit(i) {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/vehicles/${i.id}`
      },
      urlAddUser() {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/vehicles/add`
      },
      searching() {
        if (this.search.licence_plate.length > 2) {
          this.searchVehicles()
        }
      },
      async searchVehicles() {
        this.loading = true
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/vehicles-search`
        //this.$store.dispatch('quote/setRequest', this.rq)
        this.$axios.get(url, {params: this.search}).then(rs => {
          this.loading = false
          this.vehiclesDynamic = rs.data.data
        })
        .catch(error=> {
          if (error.response) {
            this.errors = error.response.data.errors
          }  else {
            this.errors = {
              unexpected: ['Hubo un error por favor contacte al administrador']
            }
          }
          console.log('error quote', error);
          this.loading = false
        })
      }
    }
  }
</script>